<template lang="pug">
tr.vue-time-entries-weekly-table-row(:class="{ archived: isArchivedProject(project) }")
  td.table-data-end.d-flex
    AppAvatarInitial.valign-top(:text="project.text")
      i.hi-work-break(v-if="isWorkBreak")
    .project-data.inline-block
      .project-info.cell-max-width
        .strong.ellipsis
          | {{ project.text }} {{ isWorkBreak && paid ? ' $' : '' }}
        .upcase-text.task-text.ellipsis(v-if="task")
          | {{ task.text }}
        .small.ellipsis.is-muted(v-else) {{ noTaskText }}
  TimeEntriesWeeklyTableRowTableData(
    v-for="date in dateRange"
    :key="date.format()"
    :time-entries="filterByDate(timeEntries, date)"
    :date="date"
    :is-copy="isCopy"
    :project="project"
    :task="task"
    :work-break-policy-id="workBreakPolicyId"
  )
  td.strong.vue-time-entries-weekly-table-row-table-data
    | {{ sumDuration(timeEntries) | formatDuration(null, '-') }}
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimeEntriesWeeklyTableRow',
  props: {
    project: {
      type: Object,
      default: null,
    },
    task: {
      type: Object,
      default: null,
    },
    timeEntries: {
      type: Array,
      default: () => [],
    },
    workBreakPolicyId: {
      type: Number,
      default: null,
    },
    isCopy: { type: Boolean },
    dateRange: Array,
  },
  computed: {
    ...mapGetters(['sumDuration', 'filterByDate', 'isArchivedProject', 'getWorkBreakPolicy']),
    noTaskText() {
      if (this.isWorkBreak) {
        return 'Work break';
      }
      if (this.project.work_order) {
        return 'No job';
      }

      return 'No to-do';
    },
    isWorkBreak() {
      return !!this.workBreakPolicyId;
    },
    paid() {
      return this.workBreakPolicyId && this.getWorkBreakPolicy(this.workBreakPolicyId).paid;
    },
  },
};
</script>
